import { ShowButton, useTable, List, TextField } from "@refinedev/antd";
import { useNavigation } from "@refinedev/core";
import { Space, Table, Tag } from "antd";
import { AppImagePreview } from "../../components";
import s from "../News/Pinned-News/Pinned-News.module.scss";
import { CommentatorDelete } from "./CommentatorDelete";
import { BmsMappingCell } from "./BmsMapping";

export function CommentatorsList() {
  const { push } = useNavigation();

  const { tableProps, searchFormProps } = useTable<any[]>({
    dataProviderName: "commentatorsDataProvider",
    resource: "commentators",
    meta: {},
    syncWithLocation: false,
    queryOptions: {
      enabled: true,
    },
  });

  const handleNavigateToEdit = (id: string) => {
    push(`/commentators/${id}`);
  };

  return (
    <List
      title={"Комментаторы"}
      resource={"commentators"}
      breadcrumb={false}
      canCreate={true}
      createButtonProps={{
        children: "Добавить комментатора",
        onClick: () => push("/commentators/create"),
      }}
      wrapperProps={{ style: { position: "sticky", top: 24 } }}
    >
      <Table
        {...tableProps}
        scroll={{ x: 1200 }}
        rowKey="id"
        locale={{
          emptyText: <div style={{ margin: 56 }}>Комментаторы отсутствуют</div>,
        }}
        showSorterTooltip={false}
        pagination={{
          ...tableProps.pagination,
          showSizeChanger: true,
          showTotal: (total, range) =>
            `Показано ${range[0]}-${range[1]} из ${total} комментаторов`,
        }}
      >
        <Table.Column<any>
          width={200}
          dataIndex={"photo"}
          key="photo"
          title="Фото"
          render={(photoUrl) =>
            photoUrl ? (
              <AppImagePreview
                imageURL={photoUrl}
                useS3={true}
                sharedStyles={s.imageUrl}
              />
            ) : (
              <div
                style={{
                  width: 50,
                  height: 50,
                  backgroundColor: "#f0f0f0",
                  borderRadius: 4,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#999",
                  fontSize: 12,
                }}
              >
                Нет фото
              </div>
            )
          }
        />

        <Table.Column<any>
          width={120}
          key="fullName"
          title="ФИО"
          sorter={(a, b) => {
            const getFullName = (item: any) =>
              `${item.lastName} ${item.firstName} ${item.patronymic}`;
            return getFullName(a).localeCompare(getFullName(b));
          }}
          render={(_, record) => {
            const formatName = (item: any) => {
              const last = item.lastName || "";
              const first = item.firstName
                ? `${item.firstName.charAt(0)}.`
                : "";
              const patronymic = item.patronymic
                ? `${item.patronymic.charAt(0)}.`
                : "";
              return `${last} ${first}${patronymic}`.trim();
            };

            return <TextField value={formatName(record)} />;
          }}
        />

        <Table.Column<any>
          width={150}
          dataIndex={"city"}
          key="city"
          title="Город"
          sorter={(a, b) => a.city?.localeCompare(b.city)}
          render={(value) => <TextField value={value} />}
        />

        <Table.Column<any>
          width={150}
          dataIndex={"birthdate"}
          key="birthdate"
          title="Дата рождения"
          sorter={(a, b) =>
            new Date(a.birthdate).getTime() - new Date(b.birthdate).getTime()
          }
          render={(birthdate) => (
            <TextField
              value={
                birthdate
                  ? new Date(birthdate).toLocaleDateString("ru-RU")
                  : "-"
              }
            />
          )}
        />

        <Table.Column<any>
          width={200}
          key="bmsMapping"
          title="Комментатор в BMS"
          render={(_, record) => <BmsMappingCell commentatorId={record.id} />}
        />

        <Table.Column<any>
          width={200}
          fixed={"right"}
          key="actions"
          title="Действия"
          render={(_, record) => {
            const fullName = `${record.lastName} ${record.firstName} ${
              record.patronymic || ""
            }`.trim();

            return (
              <Space size={8} direction="vertical" style={{ width: "100%" }}>
                <ShowButton
                  onClick={() => handleNavigateToEdit(String(record.id))}
                  size={"small"}
                  block
                >
                  Смотреть / Редактировать
                </ShowButton>
                <CommentatorDelete id={record.id} name={fullName} />
              </Space>
            );
          }}
        />
      </Table>
    </List>
  );
}
